import React, { useCallback, useEffect, useState } from 'react'
import { axiosPost } from '../../../utils/AxiosApi';
import { URL } from '../../../utils/Constants';
import Pagination from '../../UI/Pagination';
import { Spinner } from 'reactstrap';
import { get } from 'jquery';
import DataTable from 'react-data-table-component';

const ListAllTeachers = ({teachers}) => {
    const [listTeachers, setListTeachers] = useState(teachers ||[]);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [totalRecords, setTotalRecords] = useState(0);
    const [loading, setLoading] = useState(false);
    
    

    const getAllTeachers = useCallback(() => {
        setLoading(true);
        let param = {
            // offset: (currentPage - 1) * pageSize,
            // rowCountLimit: pageSize
        }
        axiosPost(URL.getSubjectTeachers, param, (response) => {
            if (response.status === 200) {
                // setListTeachers(response.data.data);
                // setTotalRecords(response.data.totalRecordsCount);
            }
            setLoading(false);
        });
    },[currentPage, pageSize])
    useEffect(() => {
        getAllTeachers();
    }, [getAllTeachers]);

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handleNextPage = () => {
        setCurrentPage(prev => prev + 1);
    };

    const handlePreviousPage = () => {
        setCurrentPage(prev => Math.max(1, prev - 1));
    };

    const columns = [
	{
		name: 'Name',
		selector: row => row.people?.name || row.name,
        sortable: true,

	},
	{
		name: 'Class',
		selector: row => row.class,
        sortable: true,

	},
    {
		name: 'Department',
		selector: row => row.staffTypeName,
        sortable: true,
	},
    {
        name: 'Role',
        selector: row => row.role,
        sortable: true,
        cell: row => (
            <span className={`badge ${row?.role === "Coordinator" ? "badge-primary" : "badge-secondary"}`}>
                {row?.role}
            </span>
        )
	},
    {
		name: 'Subjects',
		selector: row => row.subjects,
        sortable: true,

	},
    {
		name: 'Students',
		selector: row => row.students,
        sortable: true,
	},
    {
		name: 'Pass Rate',
		selector: row => row.passRate,
        sortable: true,
        cell: row => (
            <span className={`badge ${
              row.passRate >= 85 ? "badge-success" :
              row.passRate >= 70 ? "badge-warning" :
              "badge-danger"
            }`}>
              {row.passRate}%
            </span>
          )
	},
    {
		name: 'Avg Marks',
		selector: row => row.avgMarks,
        sortable: true,
        cell: row => (
            <span>
              {row.avgMarks}%
            </span>
          )
	},
    {
		name: 'Attendance',
		selector: row => row.attendance,
        sortable: true,
        cell: row => (
            <span>
              {row.attendance}%
            </span>
        )
	},
    {
		name: 'Evaluation',
		selector: row => row.evaluation,
        sortable: true,
        cell : row =>(
             <span className="badge badge-primary">{row?.evaluation}/5.0</span>
        )
	},
];
  return (
      <div className="card">
      <div className="card-body">
        <h5 className="card-title mb-4">All Staffs ({totalRecords}) </h5>
        <DataTable columns={columns} data={listTeachers} pagination={true} progressPending={loading} noDataComponent="No Teachers found." />
        {/* <div className="table-responsive" style={{ maxHeight: "600px", overflowY: "auto" }}>
          <table className="table table-hover table-sm">
            <thead className="thead-light" style={{ position: "sticky", top: 0, backgroundColor: "#f8f9fa", zIndex: 1 }}>
              <tr>
                <th>S.N</th>
                <th>Name</th>
                <th>Class</th>
                <th>Department</th>
                <th>Role</th>
                <th>Subjects</th>
                <th>Students</th>
                <th>Pass Rate</th>
                <th>Avg Marks</th>
                <th>Attendance</th>
                <th>Evaluation</th>
              </tr>
            </thead>
            <tbody>
              {listTeachers.length > 0? (listTeachers.map((teacher, index) => (
                <tr key={teacher?.id}>
                  <td>{index + 1}</td>
                  <td className="font-weight-bold">{teacher?.people?.name || teacher?.name}<br/><span className="badge badge-primary">{teacher?.evaluation}/5.0</span></td>
                  <td>
                    <span className="badge badge-info">
                       {teacher?.class}
                    </span>
                  </td>
                  <td><small>{teacher?.staffTypeName}</small></td>
                  <td>
                    <span className={`badge ${teacher?.role === "Coordinator" ? "badge-primary" : "badge-secondary"}`}>
                      {teacher?.role}
                    </span>
                  </td>
                  <td><small>{teacher?.subjects}</small></td>
                  <td className="text-center">{teacher?.students}</td>
                  <td>
                    <span className={`badge ${
                      teacher?.passRate >= 85 ? "badge-success" :
                      teacher?.passRate >= 70 ? "badge-warning" :
                      "badge-danger"
                    }`}>
                      {teacher?.passRate}%
                    </span>
                  </td>
                  <td className="text-center">{teacher?.avgMarks}%</td>
                  <td className="text-center">{teacher?.attendance}%</td>
                  <td className="text-center">
                    <span className="badge badge-primary">{teacher?.evaluation}/5.0</span>
                  </td>
                </tr>
                
              ))): (
                <tr>
                 <td colSpan="11" className='d-flex mt-3 mb-3 align-item-center justify-content-center'>
                    {loading ? (
                        <div className="d-flex flex-column align-items-center">
                        <Spinner></Spinner>
                        </div>
                    ) :(
                        <div className="alert alert-info">
                       No Teachers found.
                      </div>
                    )}
                    </td>
                </tr>
              )}
            </tbody>
          </table>
                  <div
                      style={{
                          display: "flex",
                          justifyContent: "center",
                          marginTop: "20px",
                      }}
                  >
                      <Pagination
                          itemsCount={totalRecords}
                          pageSize={pageSize}
                          currentPage={currentPage}
                          onPageChange={handlePageChange}
                          nextPage={handleNextPage}
                          previousPage={handlePreviousPage}
                      ></Pagination>
                  </div>
        </div> */}
      </div>
    </div>
  )
}

export default ListAllTeachers